import request from '@/utils/request';
import { PageResult } from '@/api/typing';

export async function create_back_order(params: Record<string, any>) {
  return request.post('/jms/create_back_order', params);
}

export async function delete_back_order(params: Record<string, any>) {
  return request.post('/jms/delete_back_order', params);
}

export async function query_back_order_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/jms/query_back_order_list', params);
}

export async function create_company_staff(params: Record<string, any>) {
  return request.post('/jms/create_company_staff', params);
}

export async function get_franchisee_by_id(params: Record<string, any>) {
  return request.post('/jms/get_franchisee_by_id', params);
}

export async function update_company_staff(params: Record<string, any>) {
  return request.post('/jms/update_company_staff', params);
}

export async function delete_company_staff(params: Record<string, any>) {
  return request.post('/jms/delete_company_staff', params);
}

export async function recover_company_staff(params: Record<string, any>) {
  return request.post('/jms/recover_company_staff', params);
}

export async function query_company_staff_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/jms/query_company_staff_list', params);
}

export async function create_franchisee(params: Record<string, any>) {
  return request.post('/jms/create_franchisee', params);
}

export async function update_franchisee(params: Record<string, any>) {
  return request.post('/jms/update_franchisee', params);
}

export async function delete_franchisee(params: Record<string, any>) {
  return request.post('/jms/delete_franchisee', params);
}

export async function recover_franchisee(params: Record<string, any>) {
  return request.post('/jms/recover_franchisee', params);
}

export async function query_franchisee_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/jms/query_franchisee_list', params);
}

export async function create_franchisee_c_z_record(params: Record<string, any>) {
  return request.post('/jms/create_franchisee_c_z_record', params);
}

export async function delete_franchisee_c_z_record(params: Record<string, any>) {
  return request.post('/jms/delete_franchisee_c_z_record', params);
}

export async function query_franchisee_c_z_record_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/jms/query_franchisee_c_z_record_list', params);
}

export async function query_franchisee_wallet_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/jms/query_franchisee_wallet_list', params);
}

export async function create_product(params: Record<string, any>) {
  return request.post('/jms/create_product', params);
}

export async function update_product(params: Record<string, any>) {
  return request.post('/jms/update_product', params);
}

export async function delete_product(params: Record<string, any>) {
  return request.post('/jms/delete_product', params);
}

export async function recover_product(params: Record<string, any>) {
  return request.post('/jms/recover_product', params);
}

export async function query_product_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/jms/query_product_list', params);
}

export async function create_product_order(params: Record<string, any>) {
  return request.post('/jms/create_product_order', params);
}

export async function query_product_order_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/jms/query_product_order_list', params);
}

export async function query_product_price_change_record_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/jms/query_product_price_change_record_list', params);
}

export async function create_request_order(params: Record<string, any>) {
  return request.post('/jms/create_request_order', params);
}

export async function update_request_order(params: Record<string, any>) {
  return request.post('/jms/update_request_order', params);
}

export async function delete_request_order(params: Record<string, any>) {
  return request.post('/jms/delete_request_order', params);
}

export async function agree_request_order(params: Record<string, any>) {
  return request.post('/jms/agree_request_order', params);
}

export async function refuse_request_order(params: Record<string, any>) {
  return request.post('/jms/refuse_request_order', params);
}

export async function get_product(params: Record<string, any>) {
  return request.post('/jms/get_product', params);
}

export async function update_send_order(params: Record<string, any>) {
  return request.post('/jms/update_send_order', params);
}

export async function makesure_send_order(params: Record<string, any>) {
  return request.post('/jms/makesure_send_order', params);
}

export async function send_product_order(params: Record<string, any>) {
  return request.post('/jms/send_product_order', params);
}

export async function remove_product_order(params: Record<string, any>) {
  return request.post('/jms/remove_product_order', params);
}

export async function recover_request_order(params: Record<string, any>) {
  return request.post('/jms/recover_request_order', params);
}

export async function query_request_order_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/jms/query_request_order_list', params);
}

export async function create_send_order(params: Record<string, any>) {
  return request.post('/jms/create_send_order', params);
}

export async function delete_send_order(params: Record<string, any>) {
  return request.post('/jms/delete_send_order', params);
}

export async function query_send_order_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/jms/query_send_order_list', params);
}

export async function create_product_type(params: Record<string, any>) {
  return request.post('/jms/create_product_type', params);
}

export async function update_product_type(params: Record<string, any>) {
  return request.post('/jms/update_product_type', params);
}

export async function delete_product_type(params: Record<string, any>) {
  return request.post('/jms/delete_product_type', params);
}

export async function recover_product_type(params: Record<string, any>) {
  return request.post('/jms/recover_product_type', params);
}

export async function query_product_type_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/jms/query_product_type_list', params);
}
